import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Center, Loader } from '@mantine/core';
import { useAuth } from '../features/auth/useAuth';

/**
 * Entry point at "/" — works out where the visitor actually belongs:
 * signed in goes to the app shell, anonymous goes to sign-in.
 *
 * This matters most for "App Mode": "/" is the manifest's start_url, so this is
 * what the installed standalone window opens on every launch. It replaced the
 * M1.2 scaffolding page ("Send health probe" / correlation-ID smoke test), which
 * the installed app used to launch into.
 *
 * Redirects `replace: true` so the launch URL doesn't linger in history — "/"
 * has nothing to go back to.
 */
export function IndexRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;
    void navigate({ to: isAuthenticated ? '/app' : '/login', replace: true });
  }, [isLoading, isAuthenticated, navigate]);

  // This route never shows content of its own — it only ever redirects, so the
  // loader covers the `/me` probe on a cold start.
  return (
    <Center mih="100vh">
      <Loader color="invetrak" />
    </Center>
  );
}
